var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWomanShape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "65px",
    viewBox: "0 0 36 65",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8106679C-C4FF-4CC1-9585-DA03DD8574B7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9.-Efficiency-of-Hana-UI",
    transform: "translate(-384.000000, -289.000000)",
    strokeWidth: 2.10000008
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(386.000000, 291.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.06138528,18.5722057 C7.06138528,18.5722057 18.9304358,23.9057559 21.7850859,25.182706 C24.639586,26.4598061 25.766536,29.1641562 24.489586,31.4179062 C23.2123359,33.6715063 18.6299857,31.4179062 18.6299857,31.4179062 L-1.50000006e-05,22.5535059 L2.85463511,0.000105000004",
    id: "Stroke-1",
    stroke: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7003056,8.50594534 L19.0807058,16.3936957 C19.0807058,16.3936957 32.3020063,20.9760458 32.4523063,30.9670962 C32.6026063,40.9582966 25.011706,45.0898968 25.011706,45.0898968 L27.1937561,53.0527971 L-4.50000018e-05,53.0527971 L2.6096551,29.4324462",
    id: "Stroke-3",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.46035026,
    y1: 61.7666275,
    x2: 5.18325021,
    y2: 53.0526771,
    id: "Stroke-5",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.2272106,
    y1: 61.7666275,
    x2: 18.7803607,
    y2: 53.0526771,
    id: "Stroke-7",
    stroke: "#222456"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanShape);
export default __webpack_public_path__ + "static/media/womanShape.34de0fe4.svg";
export { ForwardRef as ReactComponent };